import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import middleware from './middleware';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(() => {});
};

Vue.use(Router);

const router = new Router(routes);

middleware(router);

export default router;
